import React, { useState, useEffect } from "react";
import { PostApi, GetApi, xhrPost } from "../../../js_assets/Network";
import { getParameterByName } from "../../../js_assets/getParameterByName";
import { CircularProgress, Dialog } from '@material-ui/core';

import AppAdminContainer from "../AppAdminContainer";
export default function Notfications() {
  const [Admin_Info, setAdmin_Info] = useState(
    JSON.parse(localStorage.getItem("Admin_Info"))
  );
  const [data, setData] = useState(null);
  const [title, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [requestReference, setRequestsReference] = useState(null)


  console.log("Admin_Info", Admin_Info)

  function handleSubmit() {
    setLoading(true);
    setIsDone(false)
    let body = {
      titleNotification: title,
      messageNotification: data,
    };
    // PostApi(
    //   `/api/admin/Send_Notification_To_Users/${Admin_Info.admin_Id}`,
    //   body,
    //   Admin_Info.jwT_Token_Admin
    // ).then((rep) => {
    //   setLoading(false);
    // });

    xhrPost(body,
      `/api/admin/Send_Notification_To_Users/${Admin_Info.admin_Id}`
      ,
      // 1. progress
      (event) => {
        console.log('progress:', event)

      },
      // 2. error
      (errorDetails) => {
        console.log('error:', errorDetails)
        alert('لم يتم الإرسال، قد يكون أخذ وقت أكثر من المعتاد.' + '\n' + errorDetails)

      }, (url) => {
        console.log('done:', url)
        setLoading(false);
      },
      setRequestsReference,
      Admin_Info.jwT_Token_Admin
    )


  }
  function handleChangetitle(event) {
    setTitle(event.target.value);
  }
  function handleChangeData(event) {
    setData(event.target.value);
  }
  return (
    <AppAdminContainer Title={"الاشعارات"}>
      <div className="container" >
        <Dialog
          open={loading}
        >
          <div className="center" >
            <CircularProgress color="secondary" />
            <div
              style={{ paddingRight: '25%', }}
            >
              <h3
                style={{ color: 'white' }}
              >الرجاء الانتظار حتى يتم الارسال لاتغلق النافذها</h3>
              <br />
              <br />
              <h5
                style={{ color: 'white' }}
              >رح صلح لك قهوه ☕</h5>
            </div>

          </div>

        </Dialog>
        <div>
          <div >
            <label> عنوان الاشعار</label>
          </div>
          <div>
            <input

              value={title}

              onChange={handleChangetitle}
            />
          </div>
          <div >
            <label>نص الاشعار</label>
          </div>
          <textarea
            rows={5}
            value={data}
            onChange={handleChangeData}
          />
          {isDone && <span style={{ color: "tomato" }}>تم ارسال الاشعار</span>}
        </div>
        <div className="center" >
          <button

            onClick={() => handleSubmit()}

          >
            ارسال الاشعار
          </button>
        </div>

      </div>
    </AppAdminContainer>
  );
}
